import type { BillingItemBaseType } from '@/types/billing.types';
import type { EmailLogResponse } from '@/types/types';
import type { WorkOrderGetByIdResponse } from '@/types/workOrder.types';
import type { UserResponse } from '@/types/workOrderAttempt.types';

export type InvoiceUpdateSchemaType = {
  invoiceNumber?: string | null;
  status?: InvoiceStatus | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  updatedBy?: Partial<UserResponse> | null;
  billingItems?: {
    create?:
      | (Partial<BillingItemBaseType> & {
          itemId: string;
          amount: number;
        })[]
      | null;
    update?:
      | (Partial<BillingItemBaseType> & {
          billingItemId: string;
        })[]
      | null;
    delete?: string[] | null;
  } | null;
};

export type InvoiceBillingItemsSchemaType = {
  id?: string | null;
  itemId?: string | null;
  invoiceNumber?: string | null;
  amount?: number | null;
  billingItem?: Partial<BillingItemBaseType> | null;
};

/* ------------------ Invoice Response Type ------------------ */

export type InvoiceResponse = {
  invoiceNumber?: string | null;
  status?: InvoiceStatus | null;
  totalAmount?: number | null;
  balance?: number | null;
  adjustAmount?: number | null;
  memo?: string | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  billDate?: string | Date | null;
  confirmedAt?: string | Date | null;
  updatedBy?: Partial<UserResponse> | null;
  invoiceBillingItems?: InvoiceBillingItemsSchemaType[] | null;
  workOrder?: WorkOrderGetByIdResponse;
  emailLogs?: EmailLogResponse[] | null;
};

export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  REVIEWED = 'REVIEWED',
  CONFIRMED = 'CONFIRMED',
  PAID = 'PAID',
}

/* ------------------ Invoice Update Response Type ------------------ */
export type InvoiceUpdateResponseType = {
  message: string;
};
